<div class="image-player-container" *ngIf="!fullScreen">
  <h4>{{siteTwin.siteName}}</h4>
  <div>{{siteTwin.LatestTime}}</div>
  <table class="small-table">
    <tr *ngFor="let param of siteTwin.parameters | keyvalue | slice:0:10">
      <td>{{param.value.name}}</td>
      <td>{{param.value.latestValue.value}} {{param.value.units}}</td>
    </tr>
  </table>
</div>

<div class="image-player-container" *ngIf="fullScreen && selectedImageKey">
 
</div>